import * as React from "react";
import { connect } from "react-redux";

import { RootState, Dispatch } from "../../../store/types";
import { Product } from "../../../models";
import { history } from "../../../store";
import Price from "./Price";
import PriceItem from "./PriceItem";
import PriceDefault from "./PriceDefault";
import ProductSearch, { actions as searchActions } from "../../ProductSearch";
import { actions as step1Actions } from "../../Step1";

export interface PriceContainerProps {
  resetSearchValue: () => void;
  setStep1Product: (p: Product) => void;
}

export interface PriceContainerState {
  chosenProduct?: Product;
}

class PriceContainer extends React.Component<
  PriceContainerProps,
  PriceContainerState
> {
  public state: PriceContainerState = {};

  public render() {
    return (
      <Price searchInput={this.renderSearchInput()}>
        {this.renderChildren()}
      </Price>
    );
  }

  private renderSearchInput = () =>
    <ProductSearch
      onProductChoice={this.chooseProduct}
      onKeyDown={this.handleSearchKeydown}
    />;

  private handleSearchKeydown = (
    event: React.KeyboardEvent<HTMLInputElement>,
  ): void => {
    if (event.key === "Escape") {
      // Allow a way to get back to default view
      this.props.resetSearchValue();
      this.setState(state => ({ ...state, chosenProduct: undefined }));
    }
  };

  private chooseProduct = (product?: Product) =>
    this.setState(state => ({ ...state, chosenProduct: product }));

  private goToDesign = (event: Event): void => {
    // Should always be defined in this event handler
    const product = this.state.chosenProduct as Product;

    this.props.setStep1Product(product);
    history.push(`wizard/step-1/products/${product.id}`);
  };

  private renderChildren() {
    const { chosenProduct } = this.state;

    if (!chosenProduct) {
      return <PriceDefault />;
    }

    return (
      <PriceItem
        chosenProduct={chosenProduct}
        onDesignClick={this.goToDesign}
      />
    );
  }
}

const mapStateToProps = (
  state: RootState,
): Partial<PriceContainerProps> => ({});

const mapDispatchToProps = (
  dispatch: Dispatch,
): Partial<PriceContainerProps> => ({
  resetSearchValue: () => dispatch(searchActions.setSearchVal()),
  setStep1Product: (p: Product) => dispatch(step1Actions.setChosenProduct(p)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PriceContainer);



// WEBPACK FOOTER //
// ./src/routes/Price/components/PriceContainer.tsx